module.exports = __webpack_public_path__ + "static/media/1230_Music_KidsYoungChild_HL.9fdcc2cd.png";